export default __webpack_public_path__ + "static/media/background.db8265e8.png";